import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 43 43",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m36.64 31.989-6.699-3.876a10.724 10.724 0 0 1-8.45 4.122c-3.299 0-6.415-1.52-8.448-4.122L6.345 31.99l-2.673 1.538a23.068 23.068 0 0 0 2.61 3.168 21.5 21.5 0 0 0 30.419 0 23.074 23.074 0 0 0 2.611-3.168l-2.673-1.538zm.06-25.745h.001A21.33 21.33 0 0 0 23.028 0v10.888a10.7 10.7 0 0 1 6.573 3.59 10.719 10.719 0 0 1 2.614 7.022 11.188 11.188 0 0 1-.737 3.937l6.698 3.906 2.642 1.538A21.036 21.036 0 0 0 43 21.47 21.45 21.45 0 0 0 36.7 6.244zm-30.417 0a21.573 21.573 0 0 0-4.117 24.637l2.642-1.538 6.698-3.906a11.188 11.188 0 0 1-.737-3.937 10.72 10.72 0 0 1 2.614-7.023 10.7 10.7 0 0 1 6.573-3.589V0A21.329 21.329 0 0 0 6.283 6.244z",
  fill: "currentColor",
  "fill-rule": "nonzero"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }